import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { FlexContainer } from "../../core/components/FlexContainer";
import { PlayerCard } from "../../core/components/PlayerCard";
import { Font } from "../../core/components/TextElement";
import { ScreenSize, useScreenSize } from "../../core/util/MediaQueries";
import { PlayerText } from "../../core/components/PlayerText";
import { useContact3DPlayerList } from "../../../game/contact3d/replicatedObjects/Contact3DPlayerRecords";
export const Contact3DPlayerList = () => {
    const sortedPlayerRecords = useContact3DPlayerList();
    const screenSize = useScreenSize();
    const fontSize = React.useMemo(() => screenSize === ScreenSize.Large ? 16 : 12, [screenSize]);
    const gap = React.useMemo(() => screenSize === ScreenSize.Large ? '16px' : '10px', [screenSize]);
    const getPlayerElement = React.useCallback((playerRecord, index) => {
        const { playerId, score, username } = playerRecord;
        if (screenSize === ScreenSize.Large) {
            return _jsx(PlayerCard, { playerId: playerId, children: _jsx(PlayerText, { playerId: playerId, font: Font.Inter, fontSize: fontSize, text: `${username}: ${score} pts` }) }, index);
        }
        return _jsx("div", { children: _jsx(PlayerCard, { playerId: playerId, style: { margin: '0 auto' }, children: _jsx(PlayerText, { playerId: playerId, font: Font.Inter, fontSize: fontSize, text: `${username}: ${score} pts` }) }) }, index);
    }, [screenSize]);
    return (_jsx(FlexContainer, { gap: gap, children: sortedPlayerRecords.map((playerRecord, index) => {
            return getPlayerElement(playerRecord, index);
        }) }));
};
//# sourceMappingURL=Contact3DPlayerList.js.map